import { AxiosResponse } from "axios";
import { InstallationWorkload } from "@/model/data/workload/InstallationWorkload";
import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";

export class GetWorkloadResData extends PaginatedServiceResponseData {
    installationsList: InstallationWorkload[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }


    public parse(obj: any) {
        if (obj.ResultList && obj.ResultList.length > 0) {
            obj.ResultList.forEach(e => {
                var inst = new InstallationWorkload();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }

    }
}


